import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { initTracking, revokeTracking } from "@/utils/tracking";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("brimo_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    if (consent === "accepted") {
      initTracking();
    }
  }, []);

  const accept = () => {
    localStorage.setItem("brimo_cookie_consent", "accepted");
    initTracking();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("brimo_cookie_consent", "declined");
    revokeTracking();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0d0d0d] border-t border-white/10 p-4 pb-16 md:p-6 md:pb-6 animate-slide-up"
      data-testid="cookie-consent"
    >
      <button
        onClick={decline}
        className="absolute top-3 right-3 text-gray-500 hover:text-white transition-colors p-1 sm:hidden"
        aria-label="Cookie-Banner schließen"
        data-testid="cookie-close-mobile"
      >
        <X size={18} />
      </button>
      <div className="container mx-auto max-w-7xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1 pr-8 sm:pr-0">
          <p className="text-white text-sm font-bold mb-1">Cookie-Einstellungen</p>
          <p className="text-gray-400 text-xs leading-relaxed max-w-2xl">
            Wir nutzen Cookies und Tracking-Technologien (Google Analytics, Meta Pixel) zur Analyse und Optimierung
            unserer Website. Ihre Daten werden nur mit Ihrer Zustimmung verarbeitet.
            Mehr erfahren Sie in unserer{" "}
            <Link to="/datenschutz" className="text-[#E61D38] hover:underline">
              Datenschutzerklärung
            </Link>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0 sm:mr-14">
          <button
            onClick={decline}
            className="text-gray-400 text-xs font-bold uppercase tracking-wider px-5 py-2.5 border border-white/10 hover:border-white/30 transition-colors"
            data-testid="cookie-decline"
          >
            Nur notwendige
          </button>
          <button
            onClick={accept}
            className="bg-[#E61D38] text-white text-xs font-bold uppercase tracking-wider px-5 py-2.5 hover:bg-[#c41930] transition-colors"
            data-testid="cookie-accept"
          >
            Alle akzeptieren
          </button>
          <button
            onClick={decline}
            className="text-gray-500 hover:text-white transition-colors p-1 hidden sm:block"
            aria-label="Cookie-Banner schließen"
            data-testid="cookie-close"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
